// Copies text to the clipboard. Resolves true on success, false if every method failed.
// The modern Clipboard API can be refused at runtime (focus, permission policy, managed
// browser settings), so a refusal falls through to document.execCommand('copy') rather
// than being reported as a failure.
export async function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch (err) {
            console.warn('Clipboard API refused, trying execCommand fallback: ', err);
        }
    }
    return execCommandCopy(text);
}

function execCommandCopy(text) {
    // A textarea, not an <input>: an input strips newlines, which would truncate the
    // multi-line MLS and contract text.
    const previouslyFocused = document.activeElement;
    const temp = document.createElement('textarea');
    temp.value = text;
    temp.setAttribute('readonly', '');
    temp.style.position = 'fixed';
    temp.style.top = '0';
    temp.style.left = '0';
    temp.style.opacity = '0';
    document.body.appendChild(temp);
    try {
        temp.focus();
        temp.select();
        temp.setSelectionRange(0, text.length);
        // execCommand reports failure through its return value, not an exception.
        return document.execCommand('copy') === true;
    } catch (err) {
        console.error('execCommand copy failed: ', err);
        return false;
    } finally {
        document.body.removeChild(temp);
        if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
            previouslyFocused.focus();
        }
    }
}
